<template>
  <v-card elevation="0">
    <v-card-title>Commandes à traiter</v-card-title>
    <v-card-text>
      <template v-if="loading==false">
        <v-list dense>
          <v-list-item v-for="order in orders" :key="order.id" @click="open(order.id)">
            <v-list-item-content>{{order.service.name}} - {{order.updated_at}}</v-list-item-content>
            <v-list-item-icon>
              <v-icon color="pink" x-small>mdi-circle</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </template>
      <v-progress-circular v-else indeterminate color="orange darken-2"></v-progress-circular>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    orders: 0,
    loading: false
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.openOrders()
        .then(data => {
          this.orders = data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    open(id) {
      this.$router.push("/orders/view/" + id);
    },
    ...mapActions("statistique", ["openOrders"])
  }
};
</script>

<style>
</style>